/*
 * Copyright (C) 2023 akquinet GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and limitations under the License.
 */

export enum Specialty {
  ALLG = "ALLG",
  ANAE = "ANAE",
  ARBE = "ARBE",
  AUGE = "AUGE",
  CHIR = "CHIR",
  ALCH = "ALCH",
  GFCH = "GFCH",
  HZCH = "HZCH",
  KDCH = "KDCH",
  ORTH = "ORTH",
  PLCH = "PLCH",
  THCH = "THCH",
  UNFC = "UNFC",
  VICH = "VICH",
  FRAU = "FRAU",
  GEND = "GEND",
  GONK = "GONK",
  PERI = "PERI",
  GERI = "GERI",
  HNOH = "HNOH",
  HRST = "HRST",
  HAUT = "HAUT",
  HIST = "HIST",
  HUMA = "HUMA",
  HYGI = "HYGI",
  INNE = "INNE",
  ANGI = "ANGI",
  ENDO = "ENDO",
  GAST = "GAST",
  HAEM = "HAEM",
  KARD = "KARD",
  NEPH = "NEPH",
  PNEU = "PNEU",
  RHEU = "RHEU",
  INTM = "INTM",
  INTZ = "INTZ",
  INTO = "INTO",
  INTS = "INTS",
  TRPL = "TRPL",
  SELT = "SELT",
  KIJU = "KIJU",
  KONK = "KONK",
  KKAR = "KKAR",
  NNAT = "NNAT",
  NPAE = "NPAE",
  KPSY = "KPSY",
  LABO = "LABO",
  MIKR = "MIKR",
  MKGC = "MKGC",
  NATU = "NATU",
  NOTF = "NOTF",
  NRCH = "NRCH",
  NEUR = "NEUR",
  NUKL = "NUKL",
  GESU = "GESU",
  PALL = "PALL",
  PATH = "PATH",
  NPAT = "NPAT",
  PHAR = "PHAR",
  TOXI = "TOXI",
  REHA = "REHA",
  PSYC = "PSYC",
  FPSY = "FPSY",
  PSYM = "PSYM",
  RADI = "RADI",
  KRAD = "KRAD",
  NRAD = "NRAD",
  RECH = "RECH",
  SCHL = "SCHL",
  SPOR = "SPOR",
  STRA = "STRA",
  TRAN = "TRAN",
  TROP = "TROP",
  UROL = "UROL",
  MZKH = "MZKH",
  ORAL = "ORAL",
  KIEF = "KIEF",
  PARO = "PARO",
  ERG = "ERG",
  ERN = "ERN",
  FOR = "FOR",
  PFL = "PFL",
  ALT = "ALT",
  KIN = "KIN",
  PAT = "PAT",
  PHZ = "PHZ",
  POD = "POD",
  PRV = "PRV",
  SOZ = "SOZ",
  SPR = "SPR",
  VKO = "VKO",
  VER = "VER",
  PST = "PST",
}
